import { type FC, useState } from 'react';

import { useTranslation } from '@crehana/i18n';
import Download from '@crehana/icons/outline/Download';
import Upload from '@crehana/icons/outline/Upload';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, PrimaryButton } from '@crehana/ui';
import dynamic from 'next/dynamic';

import { HelperLinks } from './components';

const Tour = dynamic(() => import('reactour'), { ssr: false });

const { primaryMain } = colors;

interface ITourSectionProps {
  tourKeys: string[];
}

const TourSection: FC<ITourSectionProps> = ({ tourKeys }) => {
  const { t } = useTranslation();
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  const steps = [
    {
      selector: `[data-tour="${tourKeys[0]}"]`,
      showNumber: false,
      content: (
        <>
          <div className="flex w-full">
            <Download color={primaryMain} size={20} className="mr-8" />
            <p className="font-subtitle2">{t('STEP_1_INSTRUCTION_1_BUTTON')}</p>
          </div>
          <p className="font-body4 pt-12 pb-24">{t('TOUR_TITLE_1')}</p>
        </>
      ),
    },
    {
      selector: `[data-tour="${tourKeys[1]}"]`,
      showNumber: false,
      content: (
        <>
          <div className="flex w-full">
            <Upload color={primaryMain} size={20} className="mr-8" />
            <p className="font-subtitle2">{t('STEP_1_INPUT_TITLE')}</p>
          </div>
          <p className="font-body4 pt-12 pb-24">{t('TOUR_TITLE_2')}</p>
        </>
      ),
    },
  ];

  return (
    <>
      <HelperLinks handleTour={setIsTourOpen} />
      <Tour
        startAt={0}
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
        showNumber={false}
        rounded={5}
        nextButton={
          <div className="flex items-center cursor-text">
            <p className="font-label text-gray-dark pr-36">{`${currentStep}/2`}</p>
            <PrimaryButton size="xs">{t('TOUR_NEXT')}</PrimaryButton>
          </div>
        }
        lastStepNextButton={
          <div className="flex items-center cursor-text">
            <p className="font-label text-gray-dark pr-36">{`${currentStep}/2`}</p>
            <PrimaryButton size="xs">{t('TOUR_LAST')}</PrimaryButton>
          </div>
        }
        prevButton={<></>}
        showNavigation={false}
        getCurrentStep={current => setCurrentStep(current + 1)}
        className="flex flex-col items-end pt-36 px-18 pb-18"
        onAfterOpen={() => setCurrentStep(1)}
      />
    </>
  );
};

export default TourSection;
